(() => {
  const SC = (window.SC = window.SC || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: SC.currency || 'EUR',
      }).format((parseInt(cents, 10) || 0) / 100);
    } catch (e) {
      return ((parseInt(cents, 10) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  };

  const normalize = (s) =>
    (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

  const YARN_SVG =
    '<svg viewBox="0 0 128 128" aria-hidden="true"><defs><clipPath id="fbc"><circle cx="60" cy="62" r="44"/></clipPath></defs><circle cx="60" cy="62" r="44" fill="#c3362b"/><g clip-path="url(#fbc)" fill="none" stroke-linecap="round"><g stroke="#000" stroke-opacity=".22" stroke-width="2.6"><path d="M-6 18Q40 2 70 -20"/><path d="M-6 30Q40 14 70 -8"/><path d="M-6 42Q40 26 70 4"/><path d="M-6 54Q40 38 70 16"/><path d="M-6 66Q40 50 70 28"/><path d="M-6 78Q40 62 70 40"/><path d="M-6 90Q40 74 70 52"/><path d="M-6 102Q40 86 70 64"/><path d="M-6 114Q40 98 70 76"/><path d="M-6 126Q40 110 70 88"/></g><g stroke="#000" stroke-opacity=".22" stroke-width="2.6"><path d="M64 -6Q84 62 58 132"/><path d="M75 -6Q95 62 69 132"/><path d="M86 -6Q106 62 80 132"/><path d="M97 -6Q117 62 91 132"/><path d="M108 -6Q128 62 102 132"/><path d="M119 -6Q139 62 113 132"/></g><path d="M62 0C44 40 84 76 70 128" stroke="#000" stroke-opacity=".28" stroke-width="2.6"/></g></svg>';

  /* Toast */
  let toastTimer;
  const toast = (msg) => {
    const el = $('[data-sc-toast]');
    if (!el || !msg) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 4200);
  };
  SC.toast = toast;

  /* Drawers */
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d || d.open || typeof d.showModal !== 'function') return false;
    d.showModal();
    document.documentElement.classList.add('is-locked');
    return true;
  };
  SC.openDrawer = openDrawer;

  const bindDrawer = (d) => {
    if (d.dataset.bound) return;
    d.dataset.bound = '1';
    d.addEventListener('click', (e) => {
      if (e.target === d) d.close();
    });
    d.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      e.preventDefault();
      d.close();
    });
    d.addEventListener('close', () => {
      if (!$$('dialog[data-sc-drawer]').some((x) => x.open)) {
        document.documentElement.classList.remove('is-locked');
      }
      setTimeout(() => $$('[data-sc-ship]').forEach((el) => Ship.play(el)), 160);
    });
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-sc-open]');
    if (opener) {
      if (openDrawer(opener.dataset.scOpen)) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-sc-close]');
    if (closer) {
      const d = closer.closest('dialog');
      if (d) d.close();
      const panel = closer.closest('[data-sc-facets-panel]');
      if (panel) closeFacets(panel);
      return;
    }
    const cartOpener = e.target.closest('[data-sc-open-cart]');
    if (cartOpener && !document.body.classList.contains('sc-template-cart')) {
      if (openDrawer('CartDrawer')) e.preventDefault();
    }
  });

  /* Header */
  const initHeader = (root = document) => {
    const header = $('[data-sc-header]', root);
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';

    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const overlay = $('[data-sc-mega-overlay]');
    let openItem = null;
    let openTimer;
    let closeTimer;

    const setOpen = (item) => {
      if (openItem === item) return;
      if (openItem) {
        $('[data-sc-mega]', openItem).classList.remove('is-open');
        $('[data-sc-mega-trigger]', openItem).setAttribute('aria-expanded', 'false');
      }
      openItem = item;
      if (item) {
        $('[data-sc-mega]', item).classList.add('is-open');
        $('[data-sc-mega-trigger]', item).setAttribute('aria-expanded', 'true');
      }
      if (overlay) overlay.classList.toggle('is-open', !!item);
    };

    $$('[data-sc-mega-item]', header).forEach((item) => {
      const trigger = $('[data-sc-mega-trigger]', item);
      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => setOpen(item), openItem ? 0 : 80);
      });
      item.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(null), 180);
      });
      trigger.addEventListener('click', (e) => {
        if (openItem !== item && window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          setOpen(item);
        }
      });
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          setOpen(item);
          const first = $('[data-sc-mega] a', item);
          if (first) first.focus();
        }
      });
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) setOpen(null);
      });
    });

    if (overlay) overlay.addEventListener('click', () => setOpen(null));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && openItem) {
        const t = $('[data-sc-mega-trigger]', openItem);
        setOpen(null);
        t.focus();
      }
    });
  };

  const initAnnounce = (root = document) => {
    const bar = $('[data-sc-announce]', root);
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    const items = $$('.sc-announce__item', bar);
    if (items.length < 2 || reduceMotion.matches) return;
    let i = 0;
    let paused = false;
    bar.addEventListener('pointerenter', () => (paused = true));
    bar.addEventListener('pointerleave', () => (paused = false));
    bar.addEventListener('focusin', () => (paused = true));
    bar.addEventListener('focusout', () => (paused = false));
    setInterval(() => {
      if (paused || desktop.matches || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  };

  const EASE_OUT = 'cubic-bezier(.22,1,.36,1)';

  /* Free shipping bar: the yarn ball rolls along the thread, and only once the bar can be seen */
  const Ship = {
    state: new WeakMap(),
    get(el) {
      if (!this.state.has(el)) this.state.set(el, { p: null, next: null, seen: false, raf: 0, len: 0 });
      return this.state.get(el);
    },
    target(el) {
      return Math.min(1, Math.max(0, parseFloat(el.dataset.p) || 0));
    },
    init(el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      shipObserver.observe(el);
    },
    update(el, src) {
      this.init(el);
      const s = this.get(el);
      if (s.p === null) this.draw(el, this.target(el));
      s.next = { msg: $('.sc-ship__msg', src).innerHTML, done: src.classList.contains('is-done') };
      el.dataset.p = src.dataset.p;
      el.dataset.threshold = src.dataset.threshold;
      if (!el.getClientRects().length && this.target(el) === 0) this.animate(el, true);
      else this.play(el);
    },
    play(el) {
      const s = this.get(el);
      if (!s.seen || $$('dialog[open]').some((d) => !d.contains(el))) return;
      if (s.next || s.p !== this.target(el)) this.animate(el);
    },
    draw(el, p, count) {
      const s = this.get(el);
      const path = $('.sc-ship__thread', el);
      s.p = p;
      el.style.setProperty('--p', p.toFixed(4));
      el.style.setProperty('--off', (1 - p).toFixed(4));
      try {
        s.len = s.len || path.getTotalLength();
        if (s.len) {
          const box = path.ownerSVGElement.viewBox.baseVal;
          const pt = path.getPointAtLength(p * s.len);
          el.style.setProperty('--bx', (pt.x / box.width).toFixed(4));
          el.style.setProperty('--by', (pt.y / box.height).toFixed(4));
        }
      } catch (e) {}
      if (count) count.textContent = money(Math.round((parseFloat(el.dataset.threshold) || 0) * (1 - p)));
    },
    animate(el, instant) {
      const s = this.get(el);
      const to = this.target(el);
      const from = s.p === null ? 0 : s.p;
      const still = instant || reduceMotion.matches;
      const msg = $('.sc-ship__msg', el);
      let count = null;
      cancelAnimationFrame(s.raf);
      if (s.next) {
        const hadCount = !!$('[data-sc-ship-amount]', msg);
        if (msg.innerHTML !== s.next.msg) msg.innerHTML = s.next.msg;
        el.classList.toggle('is-done', s.next.done);
        s.next = null;
        count = $('[data-sc-ship-amount]', msg);
        if (hadCount !== !!count && !still) {
          msg.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], {
            duration: 360,
            easing: EASE_OUT,
          });
        }
      }
      if (still || Math.abs(to - from) < 0.001) {
        this.draw(el, to);
        return;
      }
      const final = count && count.textContent;
      this.draw(el, from, count);
      const duration = 650 + Math.abs(to - from) * 650;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        if (t < 1) {
          this.draw(el, from + (to - from) * (1 - Math.pow(1 - t, 4)), count);
          s.raf = requestAnimationFrame(step);
          return;
        }
        this.draw(el, to);
        if (count) count.textContent = final;
        if (to === 1) {
          el.classList.remove('is-celebrating');
          void el.offsetWidth;
          el.classList.add('is-celebrating');
          setTimeout(() => el.classList.remove('is-celebrating'), 700);
        }
      };
      s.raf = requestAnimationFrame(step);
    },
  };

  const shipObserver = new IntersectionObserver(
    (entries) =>
      entries.forEach((e) => {
        Ship.get(e.target).seen = e.isIntersecting;
        Ship.play(e.target);
      }),
    { threshold: 0.5 }
  );

  /* Swaps a re-rendered cart section in place: keeps the shipping bar, scroll and focus,
     and animates lines that move, arrive or leave. Returns the freshly rendered shipping bar. */
  const morphCart = (target, fresh) => {
    const animate = target.getClientRects().length > 0 && !reduceMotion.matches;
    const keyOf = (n) => {
      const line = n.closest('[data-key]');
      return line ? line.dataset.key : '';
    };
    const lines = new Map(
      $$('[data-sc-lines] > [data-key]', target).map((n) => [n.dataset.key, { node: n, top: n.getBoundingClientRect().top }])
    );
    const ticks = new Map($$('[data-sc-tick]', target).map((n) => [keyOf(n) + n.dataset.scTick, n.textContent.trim()]));
    const ships = $$('[data-sc-ship]', target);
    const scrolls = $$('[data-sc-scroll]', target).map((n) => n.scrollTop);
    const hadEmpty = !!$('.sc-cart-empty, .sc-cart-page__empty', target);
    const active = document.activeElement;
    const activeLine = active && target.contains(active) && active.closest('[data-key]');
    const focus = activeLine && { key: activeLine.dataset.key, index: $$('a, button, input', activeLine).indexOf(active) };

    target.replaceChildren(...fresh.childNodes);

    const freshShips = $$('[data-sc-ship]', target);
    freshShips.forEach((n, i) => {
      if (!ships[i]) return Ship.init(n);
      n.replaceWith(ships[i]);
      Ship.update(ships[i], n);
    });
    $$('[data-sc-scroll]', target).forEach((n, i) => (n.scrollTop = scrolls[i] || 0));

    const list = $('[data-sc-lines]', target);
    const freshLines = list ? $$(':scope > [data-key]', list) : [];
    const byKey = new Map(freshLines.map((n) => [n.dataset.key, n]));

    if (focus) {
      const line = byKey.get(focus.key);
      const el = line ? $$('a, button, input', line)[focus.index] : $('[data-sc-close]', target);
      if (el) el.focus({ preventScroll: true });
    }

    if (animate && list) {
      let anchor = null;
      Array.from(lines.values())
        .reverse()
        .forEach(({ node }) => {
          if (byKey.has(node.dataset.key)) {
            anchor = byKey.get(node.dataset.key);
            return;
          }
          node.removeAttribute('data-key');
          node.inert = true;
          list.insertBefore(node, anchor);
          anchor = node;
          const cs = getComputedStyle(node);
          node.style.overflow = 'hidden';
          node
            .animate(
              [
                {
                  height: node.offsetHeight + 'px',
                  paddingTop: cs.paddingTop,
                  paddingBottom: cs.paddingBottom,
                  borderBottomWidth: cs.borderBottomWidth,
                  opacity: cs.opacity,
                },
                { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px', opacity: 0 },
              ],
              { duration: 380, easing: EASE_OUT }
            )
            .finished.then(() => node.remove(), () => node.remove());
        });
    }

    freshLines.forEach((n) => {
      const old = lines.get(n.dataset.key);
      if (!old) {
        n.classList.add('is-entering');
        return;
      }
      if (!animate) return;
      const dy = old.top - n.getBoundingClientRect().top;
      if (Math.abs(dy) > 1) {
        n.animate([{ transform: `translateY(${dy}px)` }, { transform: 'none' }], { duration: 420, easing: EASE_OUT });
      }
    });

    $$('[data-sc-tick]', target).forEach((n) => {
      const before = ticks.get(keyOf(n) + n.dataset.scTick);
      if (before !== undefined && before !== n.textContent.trim()) n.classList.add('is-ticking');
    });

    if (!hadEmpty) $$('.sc-cart-empty, .sc-cart-page__empty', target).forEach((n) => n.classList.add('is-entering'));

    return freshShips[0] || null;
  };

  document.addEventListener('animationend', (e) => {
    if (e.target.classList) e.target.classList.remove('is-entering', 'is-ticking');
  });

  /* Cart */
  const Cart = {
    sectionIds() {
      const ids = ['sc-cart-drawer'];
      const main = $('[data-sc-main-cart]');
      if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
      return ids;
    },
    async request(url, options) {
      const res = await fetch(url, options);
      let data = {};
      try {
        data = await res.json();
      } catch (e) {
        data = {};
      }
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || (SC.strings && SC.strings.cartError));
      }
      return data;
    },
    async add(form, fields) {
      const fd = new FormData(form);
      Object.entries(fields || {}).forEach(([k, v]) => fd.set(k, v));
      fd.append('sections', this.sectionIds().join(','));
      fd.append('sections_url', window.location.pathname);
      const data = await this.request(SC.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      });
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('sc:cart', { detail: data }));
      return data;
    },
    async change(key, quantity) {
      const data = await this.request(SC.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: this.sectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('sc:cart', { detail: data }));
      return data;
    },
    render(sections) {
      if (!sections) return;
      let ship = null;
      Object.keys(sections).forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const target = document.getElementById('shopify-section-' + id);
        if (!target) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('shopify-section-' + id);
        if (fresh) ship = morphCart(target, fresh) || ship;
      });
      const root = $('[data-sc-cart-root]');
      if (root) this.setCount(parseInt(root.dataset.count, 10) || 0);
      if (ship) $$('[data-sc-ship-mirror] [data-sc-ship]').forEach((el) => Ship.update(el, ship));
    },
    setCount(n) {
      $$('[data-sc-cart-count]').forEach((el) => {
        el.classList.toggle('is-empty', n === 0);
        if (el.textContent.trim() === String(n)) return;
        el.textContent = n;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
        const btn = el.closest('.sc-cart-btn');
        if (btn) {
          btn.classList.remove('is-wiggle');
          void btn.offsetWidth;
          btn.classList.add('is-wiggle');
        }
      });
    },
  };
  SC.cart = Cart;

  const flyBall = (fromEl) => {
    if (reduceMotion.matches || !fromEl) return 0;
    const target = $$('[data-sc-open-cart]').find((el) => el.offsetParent !== null);
    if (!target) return 0;
    const a = fromEl.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    const ball = document.createElement('div');
    ball.className = 'sc-flying-ball';
    ball.innerHTML = YARN_SVG;
    ball.style.left = a.left + a.width / 2 - 15 + 'px';
    ball.style.top = a.top + a.height / 2 - 15 + 'px';
    document.body.appendChild(ball);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const lift = Math.min(160, Math.abs(dy) * 0.35 + 70);
    ball
      .animate(
        [
          { transform: 'translate(0, 0) scale(.6) rotate(0deg)', opacity: 0 },
          { transform: 'translate(0, -18px) scale(1.1) rotate(60deg)', opacity: 1, offset: 0.12 },
          {
            transform: `translate(${dx * 0.55}px, ${dy * 0.55 - lift}px) scale(1) rotate(300deg)`,
            opacity: 1,
            offset: 0.58,
          },
          { transform: `translate(${dx}px, ${dy}px) scale(.42) rotate(560deg)`, opacity: 0.85 },
        ],
        { duration: 720, easing: 'cubic-bezier(.45,0,.25,1)' }
      )
      .finished.then(() => ball.remove())
      .catch(() => ball.remove());
    return 680;
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-sc-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter || $('[type="submit"]', form);
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      await Cart.add(form, btn.dataset.quantity ? { quantity: btn.dataset.quantity } : null);
      const delay = flyBall(btn);
      btn.classList.remove('is-loading');
      btn.dataset.added = (SC.strings && SC.strings.added) || 'Ajouté';
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1800);
      setTimeout(() => openDrawer('CartDrawer'), delay);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sc-line-qty]');
    if (!b) return;
    const line = b.closest('[data-key]');
    if (!line) return;
    e.preventDefault();
    line.classList.add('is-updating');
    try {
      await Cart.change(line.dataset.key, Math.max(0, parseInt(b.dataset.scLineQty, 10) || 0));
    } catch (err) {
      toast(err.message);
      line.classList.remove('is-updating');
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-sc-line-input]');
    if (!input) return;
    const line = input.closest('[data-key]');
    if (!line) return;
    line.classList.add('is-updating');
    let q = Math.max(0, parseInt(input.value, 10) || 0);
    if (input.max) q = Math.min(q, parseInt(input.max, 10));
    try {
      await Cart.change(line.dataset.key, q);
    } catch (err) {
      toast(err.message);
      line.classList.remove('is-updating');
    }
  });

  /* Disclosure toggles */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sc-toggle]');
    if (!btn) return;
    const target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    target.hidden = !open;
    if (open && !reduceMotion.matches) {
      target.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], {
        duration: 320,
        easing: 'cubic-bezier(.22,1,.36,1)',
      });
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-sc-step]');
    if (!step) return;
    const wrap = step.closest('[data-sc-stepper]');
    const input = wrap && $('input', wrap);
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.dataset.scStep, 10)));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product */
  const initProduct = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const form = $('form[data-sc-product-form][data-sc-main-form]', root);
    if (!form) return;
    const idInput = $('input[name="id"]', form);
    const qty = $('[data-sc-qty-input]', root);
    const addBtn = $('[data-sc-add-main]', root);
    const addLabel = addBtn && $('[data-label]', addBtn);
    const pickers = $$('[data-sc-picker]', root);
    const picker = pickers[0];
    const single = pickers.length === 1 && picker.dataset.single === 'true';
    const label = $('[data-sc-selected-label]', root);
    const priceEl = $('[data-sc-price]', root);
    const compareEl = $('[data-sc-compare]', root);
    const stock = $('[data-sc-stock]', root);
    const mainImg = $('[data-sc-main-image]', root);
    const mainFrame = $('[data-sc-main-frame]', root);
    const sticky = $(`[data-sc-sticky-buy="${root.dataset.sectionId}"]`);
    const stickyLabel = sticky && $('[data-sc-sticky-label]', sticky);
    const stickyBtn = sticky && $('[data-sc-sticky-add]', sticky);
    const stickyImg = sticky && $('.sc-sticky-buy__media img', sticky);

    const current = () => {
      const checked = picker && $('input:checked', picker);
      if (checked) {
        return {
          id: checked.dataset.variantId,
          price: checked.dataset.price,
          compare: checked.dataset.compare,
          available: checked.dataset.available === 'true',
          label: checked.dataset.label,
          stock: checked.dataset.stock,
        };
      }
      return {
        id: idInput.value,
        price: addBtn ? addBtn.dataset.price : 0,
        compare: addBtn ? addBtn.dataset.compare : 0,
        available: addBtn ? addBtn.dataset.available === 'true' : true,
        stock: addBtn ? addBtn.dataset.stock : undefined,
      };
    };

    /* Stock limits: what is left of a limited variant once its cart quantity is taken off (null = no limit) */
    const inCart = new Map();
    const readCart = (pairs) => {
      inCart.clear();
      pairs.forEach(([id, q]) => inCart.set(String(id), (inCart.get(String(id)) || 0) + q));
    };
    const cartData = $('[data-sc-incart]', root);
    if (cartData) {
      try {
        readCart(JSON.parse(cartData.textContent));
      } catch (e) {
        inCart.clear();
      }
    }
    const remaining = (v) => {
      if (v.stock === undefined || v.stock === '') return null;
      return Math.max(0, parseInt(v.stock, 10) - (inCart.get(String(v.id)) || 0));
    };
    const plusBtn = qty && $('[data-sc-step="1"]', qty.closest('[data-sc-stepper]'));

    const refreshButton = () => {
      if (!addBtn) return;
      const v = current();
      const left = remaining(v);
      let q = Math.max(1, parseInt((qty && qty.value) || '1', 10) || 1);
      if (left) q = Math.min(q, left);
      if (qty) {
        if (left) qty.max = left;
        else qty.removeAttribute('max');
        if (String(q) !== qty.value) qty.value = q;
      }
      if (plusBtn) plusBtn.disabled = left !== null && q >= left;
      const full = v.available && left === 0;
      addBtn.disabled = !v.available || full;
      let text = SC.strings.soldOut;
      if (full) text = addBtn.dataset.maxLabel;
      else if (v.available) text = `${SC.strings.addToCart} · ${money(parseInt(v.price, 10) * q)}`;
      if (addLabel) addLabel.textContent = text;
      if (stickyBtn) {
        stickyBtn.disabled = !v.available || full;
        stickyBtn.textContent = full ? addBtn.dataset.maxLabel : v.available ? SC.strings.addToCart : SC.strings.soldOut;
      }
      if (stickyLabel && v.label) stickyLabel.textContent = v.label;
    };

    const refreshStock = (v) => {
      if (!stock) return;
      const n = v.stock === undefined || v.stock === '' ? 0 : parseInt(v.stock, 10);
      const low = v.available && n > 0 && n < (parseInt(stock.dataset.low, 10) || 0);
      stock.classList.toggle('is-out', !v.available);
      stock.classList.toggle('is-low', low);
      const txt = $('[data-text]', stock);
      if (!txt) return;
      if (!v.available) txt.textContent = stock.dataset.outStock;
      else if (low) txt.textContent = n === 1 ? stock.dataset.lowOne : stock.dataset.lowOther.replace('[n]', n);
      else txt.textContent = stock.dataset.inStock;
    };

    document.addEventListener('sc:cart', (e) => {
      const d = e.detail || {};
      if (Array.isArray(d.items) && 'item_count' in d) {
        readCart(d.items.map((i) => [i.variant_id, i.quantity]));
      } else {
        (Array.isArray(d.items) ? d.items : [d]).forEach((i) => {
          if (i && i.variant_id) inCart.set(String(i.variant_id), i.quantity);
        });
      }
      refreshButton();
      root.dispatchEvent(new Event('sc:stock'));
    });

    /* Photos are fetched (same sizes as the main image) as soon as a swatch or thumb is hovered,
       touched or focused, and only shown once decoded: the old photo stays until the new one is ready */
    const preloaded = new Map();
    const preload = (src, srcset) => {
      if (!mainImg || !src) return Promise.resolve();
      if (!preloaded.has(src)) {
        const img = new Image();
        img.sizes = mainImg.getAttribute('sizes') || '';
        if (srcset) img.srcset = srcset;
        img.src = src;
        preloaded.set(src, img.decode().catch(() => {}));
      }
      return preloaded.get(src);
    };

    let swapId = 0;
    const swapImage = (src, srcset, alt) => {
      if (!mainImg || !src) return;
      if (mainImg.getAttribute('src') === src) return;
      const id = ++swapId;
      const slow = setTimeout(() => mainImg.classList.add('is-swapping'), 150);
      preload(src, srcset).then(() => {
        clearTimeout(slow);
        if (id !== swapId) return;
        if (srcset) mainImg.setAttribute('srcset', srcset);
        mainImg.setAttribute('src', src);
        if (alt) mainImg.setAttribute('alt', alt);
        mainImg.classList.remove('is-swapping');
      });
    };

    const warmOnIntent = (el, item, read) => {
      let hover;
      el.addEventListener('pointerover', (e) => {
        clearTimeout(hover);
        const target = item(e.target);
        if (target) hover = setTimeout(() => read(target), e.pointerType === 'mouse' ? 80 : 0);
      });
      el.addEventListener('pointerleave', () => clearTimeout(hover));
      el.addEventListener('focusin', (e) => {
        const target = item(e.target);
        if (target) read(target);
      });
    };

    if (picker) {
      form.addEventListener('change', (e) => {
        const input = e.target;
        if (input.type !== 'radio' || !input.closest('[data-sc-picker]')) return;
        if (!single) {
          if (input.dataset.variantId) {
            window.location.search = '?variant=' + input.dataset.variantId;
          }
          return;
        }
        const v = current();
        idInput.value = v.id;
        if (label) label.textContent = v.label;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          const c = parseInt(v.compare, 10) || 0;
          compareEl.hidden = !(c > parseInt(v.price, 10));
          compareEl.textContent = c ? money(c) : '';
        }
        refreshStock(v);
        swapImage(input.dataset.img, input.dataset.srcset, v.label);
        if (mainFrame && input.closest('.sc-options--colors')) {
          mainFrame.classList.toggle('is-nophoto', !input.dataset.img);
        }
        if (stickyImg && input.dataset.thumb) {
          stickyImg.removeAttribute('srcset');
          stickyImg.src = input.dataset.thumb;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        refreshButton();
      });

      if (single) {
        warmOnIntent(
          picker,
          (el) => {
            const sw = el.closest('[data-sc-swatch]');
            return sw && $('input[data-img]', sw);
          },
          (input) => preload(input.dataset.img, input.dataset.srcset)
        );
      }

      const grid = $('[data-sc-swatch-grid]', root);
      const more = $('[data-sc-swatch-more]', root);
      if (more && grid) {
        more.addEventListener('click', () => {
          const open = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded', String(open));
          grid.classList.toggle('is-expanded', open);
          more.textContent = open ? more.dataset.less || more.textContent : more.dataset.more || more.textContent;
        });
        more.dataset.more = more.textContent;
        more.dataset.less = SC.strings.showLess || more.textContent;
      }
      const search = $('[data-sc-swatch-search]', root);
      if (search) {
        const empty = $('[data-sc-swatch-empty]', root);
        search.addEventListener('input', () => {
          if (grid) grid.classList.toggle('is-searching', search.value.trim() !== '');
          const q = normalize(search.value.trim());
          let shown = 0;
          $$('[data-sc-swatch]', picker).forEach((sw) => {
            const match = !q || normalize(sw.dataset.name).includes(q);
            sw.hidden = !match;
            if (match) shown += 1;
          });
          if (empty) empty.hidden = shown > 0;
        });
      }
    }

    if (qty) qty.addEventListener('change', refreshButton);

    /* Yarn calculator: its button adds the estimated number of balls in the selected colour */
    $$('[data-sc-calc]', root).forEach((calc) => {
      const per = parseInt(calc.dataset.meters, 10);
      const out = $('[data-sc-calc-text]', calc);
      const use = $('[data-sc-calc-use]', calc);
      const useLabel = use && $('[data-label]', use);
      const chosen = $('[data-sc-calc-variant]', calc);
      const dot = $('[data-sc-calc-dot]', calc);
      let n = 0;
      const sync = () => {
        const v = current();
        if (chosen) chosen.textContent = v.label || (label ? label.textContent.trim() : '');
        if (dot) {
          const checked = picker && $('input:checked', picker);
          const swatch = checked && $('.sc-swatch__img', checked.closest('label'));
          dot.hidden = !swatch;
          if (swatch) {
            dot.style.cssText = swatch.style.cssText;
            dot.innerHTML = swatch.innerHTML;
          }
        }
        if (!use) return;
        const left = remaining(v);
        const short = v.available && left !== null && n > left;
        use.disabled = !v.available || !n || short;
        use.dataset.quantity = n;
        if (useLabel) {
          if (!v.available) useLabel.textContent = use.dataset.soldOut;
          else if (short) useLabel.textContent = use.dataset.short.replace('[count]', left);
          else useLabel.textContent = use.dataset.template.replace('[count]', n).replace('[price]', money(parseInt(v.price, 10) * n));
        }
      };
      const pick = (btn) => {
        $$('[data-sc-calc-project]', calc).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        const m = parseInt(btn.dataset.meters, 10);
        n = Math.ceil(m / per);
        if (out) {
          out.textContent = calc.dataset.template
            .replace('[project]', btn.dataset.label)
            .replace('[meters]', m)
            .replace('[count]', n)
            .replace('[per]', per);
        }
        sync();
      };
      calc.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sc-calc-project]');
        if (btn) pick(btn);
      });
      form.addEventListener('change', sync);
      root.addEventListener('sc:stock', sync);
      const first = $('[data-sc-calc-project][aria-pressed="true"]', calc) || $('[data-sc-calc-project]', calc);
      if (first) pick(first);
    });

    $$('[data-sc-thumb]', root).forEach((t) => {
      t.addEventListener('click', () => {
        $$('[data-sc-thumb]', root).forEach((x) => x.setAttribute('aria-current', String(x === t)));
        swapImage(t.dataset.src, t.dataset.srcset, t.dataset.alt);
      });
    });
    const thumbs = $('.sc-product__thumbs', root);
    if (thumbs) {
      warmOnIntent(
        thumbs,
        (el) => el.closest('[data-sc-thumb]'),
        (t) => preload(t.dataset.src, t.dataset.srcset)
      );
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        ([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        },
        { threshold: 0 }
      );
      io.observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', () => form.requestSubmit(addBtn));
    }

    refreshButton();
  };

  /* Collection filters */
  const closeFacets = (panel) => {
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    const opener = $('[data-sc-facets-open]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  };

  /* Collection navigation: rayons, shortcuts and pages swap the section in place, from a prefetched copy.
     The section alone is fetched when the target uses the same template, the full page otherwise. */
  const collectionPages = new Map();
  const collectionRoot = () => $('[data-sc-facets-root]');
  const canSwapCollections = () => !(window.Shopify && window.Shopify.designMode);
  const pageKey = (href) => {
    const u = new URL(href, window.location.origin);
    return u.pathname + u.search;
  };

  const fetchCollection = (href, template) => {
    const key = pageKey(href);
    if (collectionPages.has(key)) return collectionPages.get(key);
    const root = collectionRoot();
    const url = new URL(key, window.location.origin);
    if (root && template !== undefined && template === root.dataset.scTemplate) {
      url.searchParams.set('section_id', root.dataset.sectionId);
    }
    const req = fetch(url).then((res) => (res.ok ? res.text() : Promise.reject(new Error(res.status))));
    req.catch(() => collectionPages.delete(key));
    collectionPages.set(key, req);
    if (collectionPages.size > 24) collectionPages.delete(collectionPages.keys().next().value);
    return req;
  };

  /* The sort the shopper picked follows them from one collection to the next */
  const withSort = (a) => {
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    if (!sort || a.pathname === window.location.pathname) return a.href;
    const url = new URL(a.href, window.location.origin);
    url.searchParams.set('sort_by', sort);
    return url.href;
  };

  const prefetchCollection = (a) => {
    if (!a || !canSwapCollections() || !collectionRoot()) return;
    fetchCollection(withSort(a), a.dataset.scTemplate).catch(() => {});
  };

  const prefetchRayons = (root) => {
    const conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    const run = () => $$('[data-sc-rayons] [data-sc-collection-link]', root).forEach(prefetchCollection);
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2500 });
    else setTimeout(run, 1200);
  };

  let collectionNav = 0;
  let shownPage;
  const swapCollection = async (href, { template, push = true, scrollTarget } = {}) => {
    const root = collectionRoot();
    const nav = ++collectionNav;
    const slow = setTimeout(() => root.classList.add('is-loading'), 150);
    try {
      const html = await fetchCollection(href, template);
      if (nav !== collectionNav) return;
      const fresh = $('[data-sc-facets-root]', new DOMParser().parseFromString(html, 'text/html'));
      const wrap = fresh && fresh.closest('.shopify-section');
      const oldWrap = root.closest('.shopify-section');
      if (!wrap || !oldWrap) throw new Error('Collection section not found');

      const panel = $('[data-sc-facets-panel].is-open', root);
      if (panel) closeFacets(panel);
      const rail = $('[data-sc-rayons]', root);
      const focused = root.contains(document.activeElement) && document.activeElement.getAttribute('href');

      oldWrap.replaceWith(wrap);
      const freshRail = $('[data-sc-rayons]', fresh);
      if (rail && freshRail) freshRail.scrollLeft = rail.scrollLeft;
      if (push) window.history.pushState({ scTemplate: fresh.dataset.scTemplate }, '', href);
      if (fresh.dataset.scTitle) document.title = fresh.dataset.scTitle;
      initAll(wrap);

      if (focused) {
        const same = $$('a', fresh).find((a) => a.getAttribute('href') === focused);
        if (same) same.focus({ preventScroll: true });
      }
      const toolbar = $('.sc-toolbar', fresh);
      if (push && toolbar && toolbar.getBoundingClientRect().top < 0) {
        ((scrollTarget && $(scrollTarget, fresh)) || fresh).scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    } catch (e) {
      if (nav === collectionNav) window.location.href = href;
    } finally {
      clearTimeout(slow);
      if (nav === collectionNav) root.classList.remove('is-loading');
    }
  };

  /* Shortcut chips: the active one removes itself, back to the page the shopper picked it from */
  const CHIP_BACK = 'sc-chip-back';
  const readChipBack = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(CHIP_BACK));
    } catch (e) {
      return null;
    }
  };

  const rememberChipBack = (a) => {
    const prev = readChipBack();
    const root = collectionRoot();
    const back =
      prev && prev.to === window.location.pathname
        ? prev
        : { from: pageKey(window.location.href), template: root ? root.dataset.scTemplate : '' };
    try {
      window.sessionStorage.setItem(CHIP_BACK, JSON.stringify({ to: a.pathname, from: back.from, template: back.template }));
    } catch (e) {}
  };

  const restoreChipBack = (root) => {
    const chip = $('[data-sc-chip-remove]', root);
    const back = readChipBack();
    if (!chip || !back || back.to !== window.location.pathname) return;
    if (new URL(back.from, window.location.origin).pathname === window.location.pathname) return;
    chip.href = back.from;
    chip.dataset.scTemplate = back.template;
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-sc-collection-link]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.closest('.sc-facet__links') && !a.hasAttribute('data-sc-chip-remove')) rememberChipBack(a);
    if (!canSwapCollections() || !collectionRoot() || a.origin !== window.location.origin) return;
    e.preventDefault();
    const href = withSort(a);
    if (pageKey(href) === pageKey(window.location.href)) return;
    swapCollection(href, {
      template: a.dataset.scTemplate,
      scrollTarget: a.closest('.sc-pagination') ? '.sc-collection__body' : null,
    });
  });

  ['pointerover', 'focusin', 'touchstart'].forEach((type) =>
    document.addEventListener(type, (e) => prefetchCollection(e.target.closest && e.target.closest('a[data-sc-collection-link]')), {
      passive: true,
    })
  );

  window.addEventListener('popstate', (e) => {
    if (!canSwapCollections() || !collectionRoot() || pageKey(window.location.href) === shownPage) return;
    swapCollection(window.location.href, { template: e.state ? e.state.scTemplate : undefined, push: false });
  });

  let facetsAbort;
  const initFacets = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    restoreChipBack(root);
    const sectionId = root.dataset.sectionId;
    if (facetsAbort) facetsAbort.abort();
    facetsAbort = new AbortController();
    const { signal } = facetsAbort;
    shownPage = pageKey(window.location.href);

    if (canSwapCollections()) {
      window.history.replaceState({ ...window.history.state, scTemplate: root.dataset.scTemplate }, '');
      prefetchRayons(root);
    }

    const load = async (params) => {
      if (!root.isConnected) return;
      const url = `${window.location.pathname}?${params.toString()}`;
      root.classList.add('is-loading');
      try {
        const res = await fetch(`${window.location.pathname}?section_id=${sectionId}&${params.toString()}`);
        const html = await res.text();
        if (!root.isConnected) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-sc-results]', '[data-sc-facets-lists]', '[data-sc-active]', '[data-sc-count]', '[data-sc-facets-open-count]'].forEach(
          (sel) => {
            const fresh = $(sel, doc);
            const cur = $(sel, root);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          }
        );
        window.history.replaceState({ scTemplate: root.dataset.scTemplate }, '', url);
        shownPage = pageKey(url);
        initReveal(root);
      } catch (e) {
        window.location.href = url;
      } finally {
        root.classList.remove('is-loading');
      }
    };

    const fromForm = () => {
      const form = $('form[data-sc-facets]', root);
      const params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach((k) => {
        if (params.get(k) === '') params.delete(k);
      });
      return params;
    };

    const update = debounce(() => load(fromForm()), 320);

    root.addEventListener('change', (e) => {
      const f = e.target.form || e.target.closest('form');
      if (f && f.matches('[data-sc-facets]')) update();
    });
    root.addEventListener('submit', (e) => {
      if (!e.target.closest('form[data-sc-facets]')) return;
      e.preventDefault();
      load(fromForm());
    });
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-sc-facet-link]');
      if (!a) return;
      e.preventDefault();
      const u = new URL(a.href, window.location.origin);
      load(u.searchParams);
    });

    const panel = $('[data-sc-facets-panel]', root);
    const opener = $('[data-sc-facets-open]', root);
    if (panel && opener) {
      opener.addEventListener('click', () => {
        panel.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('is-locked');
        const f = $('button, input, a', panel);
        if (f) f.focus();
      });
      document.addEventListener(
        'click',
        (e) => {
          if (!panel.classList.contains('is-open')) return;
          if (panel.contains(e.target) || opener.contains(e.target)) return;
          closeFacets(panel);
        },
        { signal }
      );
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Escape' && panel.classList.contains('is-open')) {
            closeFacets(panel);
            opener.focus();
          }
        },
        { signal }
      );
    }
  };

  /* Tabs */
  const initTabs = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const tabs = $$('[role="tab"]', root);
    const panels = $$('[role="tabpanel"]', root);
    const select = (i, focus) => {
      tabs.forEach((t, j) => {
        t.setAttribute('aria-selected', String(i === j));
        t.tabIndex = i === j ? 0 : -1;
      });
      panels.forEach((p, j) => {
        p.hidden = i !== j;
        if (i === j) $$('[data-reveal]', p).forEach(replayReveal);
      });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
  };

  /* Creations filter */
  const initCreations = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const chips = $$('[data-sc-crea-filter]', root);
    const items = $$('[data-sc-crea-item]', root);
    const status = $('[data-sc-crea-status]', root);
    const apply = (chip) => {
      const value = chip.dataset.scCreaFilter;
      let first = true;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      items.forEach((li) => {
        const match = !value || li.dataset.tags.split(' ').includes(value);
        li.hidden = !match;
        li.classList.toggle('is-featured', match && first);
        if (match) {
          first = false;
          replayReveal(li);
        }
      });
      if (status) status.textContent = chip.dataset.label;
    };
    chips.forEach((chip) => chip.addEventListener('click', () => apply(chip)));
  };

  /* Reveal on scroll: only what starts below the fold is hidden, so nothing on screen waits for this script */
  let revealObserver;
  const initReveal = (root = document) => {
    const els = $$('[data-reveal]:not(.is-in):not(.is-pending)', root);
    if (!els.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              en.target.classList.replace('is-pending', 'is-in');
              revealObserver.unobserve(en.target);
            }
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
      );
    }
    const below = new Set(els.filter((el) => el.getBoundingClientRect().top > window.innerHeight));
    els.forEach((el) => {
      if (!below.has(el)) {
        el.classList.add('is-in');
        return;
      }
      el.classList.add('is-pending');
      revealObserver.observe(el);
    });
  };

  const replayReveal = (el) => {
    el.classList.add('is-pending');
    void el.offsetWidth;
    el.classList.replace('is-pending', 'is-in');
  };

  /* Scrubbed text */
  const initScrub = (root = document) => {
    $$('[data-sc-scrub]', root).forEach((el) => {
      if (el.dataset.bound || reduceMotion.matches) return;
      el.dataset.bound = '1';
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement('span');
            span.className = 'sc-scrub-word';
            span.textContent = part;
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
      const words = $$('.sc-scrub-word', el);
      let ticking = false;
      const paint = () => {
        ticking = false;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.86 - r.top) / (r.height + vh * 0.32)));
        const lit = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('is-lit', i < lit));
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(paint);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      paint();
    });
  };

  /* The red thread */
  const initThread = () => {
    const main = $('[data-sc-thread]');
    if (!main) return;
    const start = $('[data-thread-start]', main);
    if (!start) return;
    let svg;
    let path;
    let samples = [];
    let total = 0;
    let shown = 0;
    let target = 0;
    let raf;

    const build = () => {
      if (svg) svg.remove();
      svg = null;
      if (!desktop.matches) return;
      const W = main.clientWidth;
      const H = main.scrollHeight;
      // layout offsets, not bounding boxes: the ball and sections may still be mid entrance animation
      const offset = (node) => {
        let left = 0;
        let top = 0;
        for (let n = node; n && n !== main; n = n.offsetParent) {
          left += n.offsetLeft;
          top += n.offsetTop;
        }
        return [left, top];
      };
      const [sx, sy] = offset(start);
      const x0 = sx + start.offsetWidth * 0.5;
      const y0 = sy + start.offsetHeight * 0.5;
      // the thread leaves the ball for the nearest side margin, then runs down it with a soft sway
      // and a small curl every other section, never crossing the content
      const content = Math.min(W, 1320);
      const room = Math.max(28, (W - content) / 2);
      const toRight = x0 > W / 2;
      const gx = toRight ? W - room + Math.min(room / 2, 70) : room - Math.min(room / 2, 70);
      const out = toRight ? 1 : -1;
      const amp = Math.max(4, Math.min(12, room / 2 - 8));
      const sections = $$(':scope > .shopify-section', main);
      const bounds = [];
      sections.forEach((sec, i) => {
        if (i === 0 || sec.offsetHeight < 260) return;
        bounds.push(offset(sec)[1]);
      });
      const endY = H - 40;
      const segs = [];
      let x = x0;
      let y = y0;
      const curve = (x1, y1, x2, y2, x3, y3) => {
        segs.push([x, y, x1, y1, x2, y2, x3, y3]);
        x = x3;
        y = y3;
      };
      // full turn on the outer side of the line, entering and leaving downwards
      const curl = (cx, cy, r) => {
        const k = r * 0.5523;
        const o = out * r;
        const ok = out * k;
        curve(cx, cy + k, cx + o - ok, cy + r, cx + o, cy + r);
        curve(cx + o + ok, cy + r, cx + 2 * o, cy + k, cx + 2 * o, cy);
        curve(cx + 2 * o, cy - k, cx + o + ok, cy - r, cx + o, cy - r);
        curve(cx + o - ok, cy - r, cx, cy - k, cx, cy);
      };
      const curlR = Math.max(6, Math.min(11, (toRight ? W - gx : gx) / 2 - 3));
      curve(x0 + out * 60, y0 + 12, gx, y0 + 40, gx, y0 + 170);
      // sections with their own background hide the thread: curls only go on the plain page
      const painted = [];
      sections.forEach((sec) => {
        const inner = sec.firstElementChild;
        if (!inner) return;
        const cs = getComputedStyle(inner);
        const bg = cs.backgroundColor;
        if (cs.backgroundImage !== 'none' || (bg && bg !== 'transparent' && !/rgba\(.*,\s*0\)$/.test(bg))) {
          const top = offset(sec)[1];
          painted.push([top, top + sec.offsetHeight]);
        }
      });
      const plain = (py) => !painted.some(([t, b]) => py > t - 60 && py < b + 60);
      let sway = 1;
      let plainRuns = 0;
      bounds
        .filter((b) => b > y + 140)
        .forEach((b) => {
          const mid = (y + b) / 2;
          let withCurl = false;
          if (room >= 110 && plain(mid)) {
            withCurl = plainRuns % 2 === 0;
            plainRuns += 1;
          }
          if (withCurl) {
            const h = Math.min(150, (b - y) / 4);
            curve(gx, y + h, gx + sway * amp, mid - h, gx, mid);
            curl(gx, mid, curlR);
            curve(gx, mid + h, gx - sway * amp, b - h, gx, b);
          } else {
            const h = Math.min(170, (b - y) / 3);
            curve(gx, y + h, gx + sway * amp, mid - h, gx + sway * amp, mid);
            curve(gx + sway * amp, mid + h, gx, b - h, gx, b);
            sway = -sway;
          }
        });
      if (endY > y + 60) {
        const h = Math.min(170, (endY - y) / 3);
        curve(gx, y + h, gx + sway * amp, endY - h, gx, endY);
      }

      const f = (n) => n.toFixed(1);
      const d = `M ${f(x0)} ${f(y0)}${segs.map((c) => ` C ${f(c[2])} ${f(c[3])}, ${f(c[4])} ${f(c[5])}, ${f(c[6])} ${f(c[7])}`).join('')}`;

      // points every ~1.6px with their running length, sampled straight from the curves
      const pts = [[x0, y0, 0]];
      segs.forEach(([ax, ay, bx, by, cx, cy, ex, ey]) => {
        const n = Math.max(2, Math.ceil((Math.hypot(bx - ax, by - ay) + Math.hypot(cx - bx, cy - by) + Math.hypot(ex - cx, ey - cy)) / 1.6));
        for (let j = 1; j <= n; j += 1) {
          const t = j / n;
          const u = 1 - t;
          const px = u * u * u * ax + 3 * u * u * t * bx + 3 * u * t * t * cx + t * t * t * ex;
          const py = u * u * u * ay + 3 * u * u * t * by + 3 * u * t * t * cy + t * t * t * ey;
          const prev = pts[pts.length - 1];
          pts.push([px, py, prev[2] + Math.hypot(px - prev[0], py - prev[1])]);
        }
      });

      // wool texture: two plies twisting around each other, stray fibres on both sides.
      // Path data is relative and rounded against the rounded pen position, so it stays short without drifting.
      const r1 = (v) => Math.round(v * 10) / 10;
      const num = (v) => String(v).replace(/^(-?)0\./, '$1.');
      const pen = (start) => {
        let cx = r1(start[0]);
        let cy = r1(start[1]);
        return {
          start: `M${cx} ${cy}`,
          to(px, py) {
            const dx = r1(px - cx);
            const dy = r1(py - cy);
            cx += dx;
            cy += dy;
            return `${num(dx)} ${num(dy)}`;
          },
          at: () => [cx, cy],
        };
      };
      let seed = 7;
      const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;
      const chunks = [];
      const newChunk = (a, b) => ({ a: pen(a), b: pen(b), plyA: [], plyB: [], fibres: null, fuzz: [] });
      let chunk = null;
      let twist = 0;
      let nextFibre = 0;
      for (let i = 1; i < pts.length; i += 1) {
        const [ax, ay, al] = pts[i - 1];
        const [bx, by, bl] = pts[i];
        const span = bl - al || 1;
        const tx = (bx - ax) / span;
        const ty = (by - ay) / span;
        // ply crossings every 2.8px, alternating sides
        while (twist * 2.8 <= bl) {
          const k = (twist * 2.8 - al) / span;
          const px = ax + (bx - ax) * k;
          const py = ay + (by - ay) * k;
          const w = twist % 2 ? 1.15 : -1.15;
          const pa = [px - ty * w, py + tx * w];
          const pb = [px + ty * w, py - tx * w];
          if (!chunk) chunk = newChunk(pa, pb);
          else {
            chunk.plyA.push(chunk.a.to(...pa));
            chunk.plyB.push(chunk.b.to(...pb));
          }
          twist += 1;
          if (chunk.plyA.length === 300) {
            chunks.push(chunk);
            chunk = newChunk(chunk.a.at(), chunk.b.at());
          }
        }
        if (bl >= nextFibre && chunk) {
          nextFibre = bl + 4;
          const side = rnd() < 0.5 ? -1 : 1;
          const tilt = (rnd() - 0.5) * 2;
          const reach = 1.6 + rnd() * 3.6;
          const curl = (rnd() - 0.5) * 3;
          const dx = -ty * side * Math.cos(tilt) + tx * Math.sin(tilt);
          const dy = tx * side * Math.cos(tilt) + ty * Math.sin(tilt);
          const sx = bx - ty * side * 1.4;
          const sy = by + tx * side * 1.4;
          if (!chunk.fibres) chunk.fibres = pen([sx, sy]);
          const move = chunk.fuzz.length ? `m${chunk.fibres.to(sx, sy)}` : '';
          const c1 = `${num(r1(dx * reach * 0.6))} ${num(r1(dy * reach * 0.6))}`;
          const ex = r1(dx * reach - dy * curl);
          const ey = r1(dy * reach + dx * curl);
          const [qx, qy] = chunk.fibres.at();
          chunk.fibres.to(qx + ex, qy + ey);
          chunk.fuzz.push(`${move}q${c1} ${num(ex)} ${num(ey)}`);
        }
      }
      if (chunk && chunk.plyA.length) chunks.push(chunk);

      const NS = 'http://www.w3.org/2000/svg';
      const el = (tag, attrs) => {
        const node = document.createElementNS(NS, tag);
        Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
        return node;
      };
      svg = el('svg', { class: 'sc-thread', 'aria-hidden': 'true', width: W, height: H, viewBox: `0 0 ${W} ${H}` });
      const mask = el('mask', { id: 'sc-thread-reveal' });
      path = el('path', { class: 'sc-thread__reveal', d });
      mask.appendChild(path);
      svg.appendChild(el('defs', {})).appendChild(mask);
      const yarn = el('g', { mask: 'url(#sc-thread-reveal)' });
      const layer = (name, data) => yarn.appendChild(el('path', { class: `sc-thread__${name}`, d: data }));
      layer('halo', d);
      chunks.forEach((c) => c.fibres && layer('fuzz', c.fibres.start + c.fuzz.join('')));
      layer('shade', d);
      layer('core', d);
      chunks.forEach((c) => {
        layer('ply', `${c.a.start}l${c.plyA.join(' ')}`);
        layer('ply', `${c.b.start}l${c.plyB.join(' ')}`);
      });
      layer('sheen', d);
      svg.appendChild(yarn);
      main.prepend(svg);
      total = path.getTotalLength();
      const scale = total / pts[pts.length - 1][2];
      samples = [];
      let nextSample = 0;
      pts.forEach(([, py, len]) => {
        if (len < nextSample) return;
        samples.push([len * scale, py]);
        nextSample = len + 24;
      });
      samples.push([total, pts[pts.length - 1][1]]);
      path.style.strokeDasharray = `${total} ${total}`;
      path.style.strokeDashoffset = String(total - shown);
      tick(true);
    };

    const lengthForY = (yTip) => {
      let best = 0;
      for (let i = 0; i < samples.length; i += 1) {
        if (samples[i][1] <= yTip) best = Math.max(best, samples[i][0]);
      }
      return best;
    };

    const tick = (force) => {
      if (!svg) return;
      const mainTop = main.getBoundingClientRect().top;
      const yTip = window.innerHeight * 0.72 - mainTop;
      target = reduceMotion.matches ? total : lengthForY(yTip);
      if (reduceMotion.matches || force === 'instant') shown = target;
      cancelAnimationFrame(raf);
      const step = () => {
        shown += (target - shown) * 0.12;
        if (Math.abs(target - shown) < 0.5) shown = target;
        path.style.strokeDashoffset = String(Math.max(0, total - shown));
        if (shown !== target) raf = requestAnimationFrame(step);
      };
      step();
    };

    const rebuild = debounce(build, 200);
    window.addEventListener('scroll', () => tick(), { passive: true });
    window.addEventListener('resize', rebuild);
    window.addEventListener('load', rebuild);
    if ('ResizeObserver' in window) new ResizeObserver(rebuild).observe(main);
    desktop.addEventListener('change', rebuild);
    build();
  };

  /* Predictive search: one cache shared by every search field */
  const suggestCache = new Map();
  const initPredictive = (root = document) => {
    $$('[data-sc-predictive]', root).forEach((form) => {
      if (form.dataset.bound) return;
      const input = $('input[name="q"]', form);
      const panel = $('[data-sc-predictive-panel]', form);
      const status = $('[data-sc-predictive-status]', form);
      if (!input || !panel) return;
      form.dataset.bound = '1';
      let ctrl;
      let active = -1;

      const options = () => $$('[role="option"]', panel);
      const setActive = (i) => {
        const opts = options();
        active = i;
        opts.forEach((o, n) => o.setAttribute('aria-selected', String(n === i)));
        if (opts[i]) {
          input.setAttribute('aria-activedescendant', opts[i].id);
          opts[i].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      };
      const toggle = (open) => {
        panel.hidden = !open;
        input.setAttribute('aria-expanded', String(open));
        if (!open) setActive(-1);
      };
      const render = (html) => {
        if (!html || !form.contains(document.activeElement)) return toggle(false);
        panel.innerHTML = html.replaceAll('__PS__', input.id);
        options().forEach((o, n) => (o.id = `${input.id}-opt-${n}`));
        const count = $('[data-sc-predictive-count]', panel);
        if (status && count) status.textContent = count.textContent;
        setActive(-1);
        toggle(true);
      };

      const suggest = debounce(async () => {
        const q = input.value.trim();
        if (ctrl) ctrl.abort();
        if (q.length < 2) return toggle(false);
        const key = q.toLowerCase();
        if (suggestCache.has(key)) return render(suggestCache.get(key));
        ctrl = new AbortController();
        const params = new URLSearchParams({
          q,
          section_id: 'sc-predictive-search',
          'resources[type]': 'query,product,collection',
          'resources[limit]': '6',
          'resources[limit_scope]': 'each',
        });
        try {
          const res = await fetch(`${form.dataset.scPredictive}?${params}`, { signal: ctrl.signal });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const content = $('[data-sc-predictive-content]', doc);
          const html = content ? content.outerHTML : '';
          suggestCache.set(key, html);
          if (input.value.trim().toLowerCase() === key) render(html);
        } catch (e) {
          if (e.name !== 'AbortError') toggle(false);
        }
      }, 180);

      input.addEventListener('input', suggest);
      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.childElementCount) toggle(true);
      });
      input.addEventListener('keydown', (e) => {
        if (panel.hidden) return;
        const opts = options();
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && opts.length) {
          e.preventDefault();
          let next = active + (e.key === 'ArrowDown' ? 1 : -1);
          if (next < -1) next = opts.length - 1;
          if (next >= opts.length) next = -1;
          setActive(next);
        } else if (e.key === 'Enter' && opts[active]) {
          e.preventDefault();
          opts[active].click();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          toggle(false);
        }
      });
      panel.addEventListener('mousedown', (e) => e.preventDefault());
      form.addEventListener('focusout', (e) => {
        if (!form.contains(e.relatedTarget)) toggle(false);
      });
    });
  };

  /* Search page: results follow the query as it is typed */
  const initSearch = (root) => {
    if (root.dataset.bound) return;
    const form = $('[data-sc-search-form]', root);
    const input = form && $('input[name="q"]', form);
    if (!input) return;
    root.dataset.bound = '1';
    const status = $('[data-sc-search-status]', root);
    const cache = new Map();
    const norm = (search) => {
      const params = new URLSearchParams(search);
      return params.toString() ? '?' + params.toString() : '';
    };
    const fromForm = () => {
      const params = new URLSearchParams(new FormData(form));
      const q = (params.get('q') || '').trim();
      if (!q) return '';
      params.set('q', q);
      return norm(params);
    };
    let shown = norm(window.location.search);
    let ctrl;

    const swap = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const results = $('[data-sc-search-results]', root);
      const seen = new Set($$('[data-reveal] a[href]', results).map((a) => a.pathname));
      ['[data-sc-search-count]', '[data-sc-search-results]'].forEach((sel) => {
        const fresh = $(sel, doc);
        const cur = $(sel, root);
        if (fresh && cur) cur.replaceChildren(...fresh.childNodes);
      });
      $$('[data-reveal]', results).forEach((li) => {
        const a = $('a[href]', li);
        if (a && seen.has(a.pathname)) li.classList.add('is-in');
      });
      initReveal(results);
      if (status) {
        const empty = $('.sc-empty .sc-text', results);
        status.textContent = $('[data-sc-search-count]', root).textContent.trim() || (empty ? empty.textContent.trim() : '');
      }
    };

    const load = async (search, mode) => {
      if (search === shown) return;
      shown = search;
      const url = form.getAttribute('action') + search;
      if (mode) window.history[mode](window.history.state, '', url);
      if (ctrl) ctrl.abort();
      if (cache.has(search)) return swap(cache.get(search));
      const mine = (ctrl = new AbortController());
      root.classList.add('is-loading');
      try {
        const res = await fetch(`${url}${search ? '&' : '?'}section_id=${root.dataset.sectionId}`, { signal: mine.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        cache.set(search, html);
        swap(html);
      } catch (e) {
        if (e.name !== 'AbortError') window.location.href = url;
      } finally {
        if (ctrl === mine) root.classList.remove('is-loading');
      }
    };

    const update = debounce(() => {
      if (input.value.trim().length !== 1) load(fromForm(), 'replaceState');
    }, 260);

    input.addEventListener('input', update);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      load(fromForm(), 'replaceState');
    });
    root.addEventListener('click', async (e) => {
      const a = e.target.closest('.sc-pagination a');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      await load(norm(new URL(a.href).search), 'pushState');
      $('[data-sc-search-results]', root).scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });
    window.addEventListener('popstate', () => {
      if (!root.isConnected) return;
      input.value = new URLSearchParams(window.location.search).get('q') || '';
      load(norm(window.location.search));
    });
  };

  /* Product recommendations */
  const initRecos = (root = document) => {
    $$('[data-sc-recos]', root).forEach((el) => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      const run = async () => {
        try {
          const res = await fetch(el.dataset.url);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = $('[data-sc-recos]', doc);
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initReveal(el);
          } else {
            const sec = el.closest('.shopify-section');
            if (sec) sec.hidden = true;
          }
        } catch (e) {
          /* recommendations are optional */
        }
      };
      /* Fetched once the page is idle (or earlier if scrolled near), so the cards are ready before the visitor gets there */
      let started = false;
      const start = () => {
        if (started) return;
        started = true;
        run();
      };
      const whenIdle = () =>
        'requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 1500 }) : setTimeout(start, 300);
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          ([en]) => {
            if (en.isIntersecting) {
              io.disconnect();
              start();
            }
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(el);
      }
    });
  };

  /* Lightbox */
  const initLightbox = (root = document) => {
    $$('[data-sc-lightbox]', root).forEach((link) => {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        let box = document.getElementById('ScLightbox');
        if (!box) {
          box = document.createElement('dialog');
          box.id = 'ScLightbox';
          box.className = 'sc-lightbox';
          box.setAttribute('data-sc-drawer', '');
          box.innerHTML =
            '<button type="button" class="sc-drawer__close" data-sc-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button><figure><img alt=""><figcaption></figcaption></figure>';
          document.body.appendChild(box);
          bindDrawer(box);
        }
        const img = $('img', box);
        img.src = link.getAttribute('href');
        img.alt = link.dataset.alt || '';
        $('figcaption', box).textContent = link.dataset.caption || '';
        box.showModal();
        document.documentElement.classList.add('is-locked');
      });
    });
  };

  /* Workshop dates: switch to the "soon" state if a cached page outlived the date */
  const initEvents = (root = document) => {
    const now = Date.now() / 1000;
    $$('[data-sc-event-end]', root).forEach((el) => {
      const end = parseInt(el.dataset.scEventEnd, 10);
      if (!end || now <= end) return;
      $$('[data-sc-ev="date"]', el).forEach((n) => (n.hidden = true));
      $$('[data-sc-ev="soon"]', el).forEach((n) => (n.hidden = false));
    });
  };

  /* Loose yarn tail at time t: a wave runs from the ball to the free end, which also sways slowly.
     The end held by the ball stays put. Drawn as a smooth curve through a few points (viewBox 0 0 44 18). */
  const tailPath = (t, phase) => {
    const pts = [];
    for (let i = 0; i <= 8; i++) {
      const s = i / 8;
      const hold = 1 - (1 - s) * (1 - s);
      const wave = 3.8 * Math.sin(2 * Math.PI * (s * 1.7 - 0.55 * t) + phase);
      const sway = 1.8 * s * Math.sin(2 * Math.PI * 0.21 * t + phase * 1.7);
      pts.push([2 + 41 * s, 10 + hold * (wave + sway)]);
    }
    const f = (n) => n.toFixed(2);
    let d = `M${f(pts[0][0])} ${f(pts[0][1])}`;
    for (let i = 0; i < pts.length - 1; i++) {
      const p0 = pts[i - 1] || pts[i];
      const p1 = pts[i];
      const p2 = pts[i + 1];
      const p3 = pts[i + 2] || p2;
      d += `C${f(p1[0] + (p2[0] - p0[0]) / 6)} ${f(p1[1] + (p2[1] - p0[1]) / 6)} ${f(p2[0] - (p3[0] - p1[0]) / 6)} ${f(p2[1] - (p3[1] - p1[1]) / 6)} ${f(p2[0])} ${f(p2[1])}`;
    }
    return d;
  };

  /* Colour marquee: spin each yarn ball at the rate it would roll along the moving track,
     and let the loose tails wiggle behind (only while the marquee is on screen and not hovered) */
  const initMarquee = (root = document) => {
    $$('[data-sc-marquee]', root).forEach((el) => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      const group = $('.sc-marquee__group', el);
      const ball = $('.sc-marquee__ball', el);
      const speed = parseFloat(getComputedStyle(el).getPropertyValue('--speed'));
      if (!group || !ball || !speed) return;
      const pxPerSec = group.offsetWidth / speed;
      el.style.setProperty('--roll', `${((Math.PI * ball.offsetWidth) / pxPerSec).toFixed(2)}s`);
      el.classList.add('is-rolling');

      const tails = $$('[data-sc-tail]', el);
      if (!tails.length || reduceMotion.matches) return;
      let raf = 0;
      let last = 0;
      let clock = 0;
      const frame = (now) => {
        if (!el.isConnected) return;
        if (last && !el.matches(':hover')) clock += Math.min(0.1, (now - last) / 1000);
        last = now;
        tails.forEach((p) => p.setAttribute('d', tailPath(clock, p.dataset.scTail * 2.1)));
        raf = requestAnimationFrame(frame);
      };
      new IntersectionObserver(([e]) => {
        cancelAnimationFrame(raf);
        last = 0;
        if (e.isIntersecting) raf = requestAnimationFrame(frame);
      }).observe(el);
    });
  };

  /* Collection rayons: below 1280px the rail scrolls. Fades and prev/next buttons appear only on the
     side that hides tiles, and the active rayon is brought into view */
  const initRayons = (root = document) => {
    $$('[data-sc-rail]', root).forEach((nav) => {
      const list = $('[data-sc-rayons]', nav);
      if (!list || nav.dataset.bound) return;
      nav.dataset.bound = '1';
      const prev = $('[data-sc-rail-prev]', nav);
      const next = $('[data-sc-rail-next]', nav);

      const update = () => {
        const max = list.scrollWidth - list.clientWidth;
        const over = max > 2;
        const atStart = list.scrollLeft <= 2;
        const atEnd = list.scrollLeft >= max - 2;
        nav.classList.toggle('has-before', over && !atStart);
        nav.classList.toggle('has-after', over && !atEnd);
        if (!prev || !next) return;
        prev.hidden = next.hidden = !over;
        if (atStart && document.activeElement === prev) next.focus();
        if (atEnd && document.activeElement === next) prev.focus();
        prev.disabled = atStart;
        next.disabled = atEnd;
      };
      const page = (dir) =>
        list.scrollBy({
          left: dir * Math.max(160, list.clientWidth * 0.7),
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      if (prev) prev.addEventListener('click', () => page(-1));
      if (next) next.addEventListener('click', () => page(1));
      list.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);

      const active = $('[aria-current]', list);
      if (active && list.scrollWidth > list.clientWidth) {
        const item = active.parentElement;
        const box = list.getBoundingClientRect();
        const r = item.getBoundingClientRect();
        if (r.left < box.left || r.right > box.right) {
          list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
        }
      }
      update();
    });
  };

  /* Designer's signature: the emblem assembles the first time it scrolls into view, then on every hover or focus.
     Rewound on init, since a slow script may arrive after the CSS animation already ran off screen */
  const initSignature = (root = document) => {
    $$('[data-sc-sig]', root).forEach((sig) => {
      if (sig.dataset.bound || reduceMotion.matches || !sig.getAnimations) return;
      sig.dataset.bound = '1';
      const anims = () => sig.getAnimations({ subtree: true }).filter((a) => a.animationName);
      const replay = () => {
        const list = anims();
        if (!list.some((a) => a.playState === 'running')) list.forEach((a) => a.play());
      };
      sig.classList.add('is-waiting');
      anims().forEach((a) => (a.currentTime = 0));
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            io.disconnect();
            sig.classList.remove('is-waiting');
          },
          { threshold: 0.8 }
        );
        io.observe(sig);
      } else {
        sig.classList.remove('is-waiting');
      }
      sig.addEventListener('pointerenter', replay);
      sig.addEventListener('focus', replay);
    });
  };

  const initAll = (root = document) => {
    $$('dialog[data-sc-drawer]', root).forEach(bindDrawer);
    $$('[data-sc-ship]', root).forEach((el) => Ship.init(el));
    initHeader(root);
    initPredictive(root);
    $$('[data-sc-search]', root).forEach(initSearch);
    initAnnounce(root);
    initEvents(root);
    initMarquee(root);
    $$('[data-sc-product]', root).forEach(initProduct);
    $$('[data-sc-facets-root]', root).forEach(initFacets);
    initRayons(root);
    $$('[data-sc-tabs]', root).forEach(initTabs);
    $$('[data-sc-crea]', root).forEach(initCreations);
    initReveal(root);
    initScrub(root);
    initRecos(root);
    initLightbox(root);
    initSignature(root);
  };

  const boot = () => {
    initAll(document);
    initThread();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
